'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

export default function Home() {
  const router = useRouter();

  useEffect(() => {
    const accessToken = localStorage.getItem('ynab_access_token');
    if (!accessToken) {
      router.push('/authorize');
    } else {
      router.push('/upload');
    }
  }, [router]);

  return null;
}
